// extracted by mini-css-extract-plugin
module.exports = {"container":"overview_container__8x1dh","cloud":"overview_cloud__gT1rj","elements":"overview_elements__55tih","install":"overview_install__xLWtg","logo":"overview_logo__eTLfv"};